const pt = {
    '2nd': '2ª',
    '3rd': '3ª',
    '403_fallback_message': 'Você não tem permissão para acessar esta página. Se acredita que isso é um engano, entre em contato com o suporte técnico.',
    '403_fallback_title': 'Acesso não autorizado',
    '404_fallback_message': 'Não conseguimos encontrar a página que você está buscando.',
    '404_fallback_title': 'página não encontrada!',
    '429_fallback_message': 'parece que você está navegando muito rapidamente entre as telas. Para garantir a segurança de sua conta e manter a qualidade da sua experiência, pedimos que aguarde um momento antes de continuar.',
    '429_fallback_title': 'calma... respira!',
    '500_fallback_title': 'desculpe, algo deu errado!',
    'abortion': 'aborto',
    'accept': 'aceitar',
    'access': 'acesso',
    'access_farm_ccoms': 'Acessar C-Coms da fazenda',
    'access_item': 'acessar {item}',
    'access_management': 'gestão de acessos',
    'accesses': 'acessos',
    'account': 'conta',
    'account_plural': 'contas',
    'accumulated': 'acumulado',
    'accumulated_behavior': 'comportamento acumulado',
    'action_completed': 'ação concluída com sucesso!',
    'activate': 'ativar',
    'active_contracts': 'contratos ativos',
    'active_female_plural': 'ativas',
    'active_female_singular': 'ativa',
    'active_male': 'ativo',
    'activity': 'atividade',
    'actual_batch': 'lote atual',
    'add_condition': 'adicionar condição',
    'add_group': 'adicionar grupo',
    'add_item': 'adicionar {item}',
    'add_new_option': 'adicionar nova entrada {item}',
    'add_permissions_to_page': 'adicionar permissões na página',
    'add_permissions_to_roles': 'adicionar permissões aos papéis',
    'add_to_another_protocol': 'adicionar a outro protocolo',
    'add-to-an-existing-protocol': 'adicionar a um protocolo existente',
    'additional_info': 'informações complementares',
    'address': 'endereço',
    'adjustments': 'ajustes',
    'age_at_first_calving': 'idade ao primeiro parto',
    'ai': 'IA',
    'AI': 'IA',
    'ai_apresentation_description': 'Quanto mais específica for a pergunta, melhor conseguirei te responder',
    'ai_apresentation_title': 'Como posso te ajudar hoje?',
    'ai-hormone-implanted': 'IH-IATF',
    'aimer_cameras': 'câmeras Aimer',
    'aimer_cameras_overview':
        'A integração com a Aimer conecta os dados de monitoramento por câmeras à CowMed, permitindo acompanhar o comportamento alimentar dos lotes. As câmeras analisam continuamente o cocho e enviam indicadores que ajudam a identificar disponibilidade de alimento, ocupação e necessidade de manejo.\n\nPara saber como ter este recurso na sua fazenda, fale com os consultores comerciais da CowMed.\n\n### Como funciona\n\n1. Para utilizar a integração, o serviço de monitoramento por câmeras da Aimer deve estar instalado e operacional na fazenda. Você pode contratar o serviço através da nossa equipe comercial.\n2. Após a instalação, solicite a ativação da integração aos técnicos da Aimer ou ao time de consultores da CowMed.\n3. Com a integração ativa, os lotes da Aimer são vinculados aos lotes correspondentes cadastrados na CowMed.\n4. Após a configuração, os indicadores e alertas gerados pelas câmeras passam a ser exibidos no contexto de Nutrição da fazenda.\n\n### Dados disponíveis\n\n- Escore de cocho\n- Tempo diário de cocho vazio\n- Tempo de espera\n- Alertas de necessidade de Push Up',
    'alert_count': 'contagem de alertas',
    'alert_hourly': 'alertas por horário',
    'alert_plural': 'alertas',
    'alert_utilization': 'aproveitamento de alertas',
    'alerted_plural': 'alertados',
    'all_female': 'todas',
    'all_male': 'todos',
    'all_markings': 'todas marcações',
    'analysis': 'análises',
    'and': 'e',
    'animal': 'animal {item}',
    'animal_behavior': 'comportamento animal',
    'animal_condition_today': 'como está a condição do animal hoje?',
    'animal_departure': 'saída de animais',
    'animal_discard': 'descarte de animais',
    'animal_gender': 'qual o sexo do bezerro(a)?',
    'animal_in_protocol': 'animal em protocolo',
    'animal_lists': 'listas de animais',
    'animal_name': 'nome do animal',
    'animal_plural': 'animais {item}',
    'animals': 'animais',
    'animals_a_protocol': 'animais a um protocolo',
    'animals_for_review': 'animais para revisão',
    'animals_in_withdrawal': 'animais em carência',
    'animals_into_protocol': 'animais ao protocolo',
    'answered_at': 'respondido em',
    'api': 'api',
    'application': 'aplicação',
    'applications': 'aplicações',
    'applied': 'aplicada',
    'applied_plural': 'aplicadas',
    'apply': 'aplicar',
    'archive_item': 'arquivar {item}',
    'archived': 'arquivado',
    'assign_normal_status_to_animal': 'atribuir um status Normal para este animal',
    'attach_collar': 'vincular coleira',
    'attach_item': 'vincular {item}',
    'attach_permissions_to_roles': 'vincular permissões aos papéis',
    'attached_batches': 'lotes vinculados',
    'attached_collar': 'coleira vinculada',
    'attachment': 'vínculo',
    'authorize': 'autorizar',
    'auto_filled_data': 'dado auto-preenchido',
    'automatically_detected': '{item} detectado automaticamente',
    'available_integrations': 'integrações disponíveis',
    'available_plural': 'disponíveis',
    'available_singular': 'disponível',
    'average_birth_weight': 'Peso médio ao nascimento',
    'average_daily_gain': 'ganho médio diário',
    'average_data_stack_percentage': 'média de porcentagem da pilha de dados',
    'average_DEL': 'DEL médio',
    'average_panting': 'média de ofegação {item}',
    'average_rumination': 'ruminação média {item}',
    'average_weaning_weight': 'Peso médio ao desaleitamento',
    'b2b_screens': 'telas B2B',
    'b2c_screens': 'telas B2C',
    'back': 'voltar',
    'back_to_cowmed': 'voltar para Cowmed',
    'batch': 'lote',
    'batch_average_plural': 'média de lotes',
    'batch_diet': 'dieta do lote',
    'batch_divergence': 'divergência de lotes',
    'batch_divergence_alert': 'a localização é definida com base na concentração de pacotes enviados pelas coleiras às antenas. Falhas recentes de comunicação podem impactar a localização apresentada. Mantenha sempre atualizadas as informações de movimentação dos animais entre lotes.',
    'batch_monitoring': 'monitoramento do lote',
    'batch_move_fail': 'falha ao mover lote',
    'batch_move_success': 'lote movido com sucesso',
    'batch_plural': 'lotes',
    'battery_voltage': 'tensão da bateria',
    'best_bull_mating': 'Melhor touro para acasalamento',
    'best_time_for_ai': 'melhor horário para IA/MN',
    'birth': 'nascimento',
    'birthday': 'data de nascimento',
    'blog_and_news': 'blog e notícias',
    'blog_and_news_description': 'novidades e conteúdos',
    'body_assessment': 'avaliação corporal',
    'body_score': 'escore corporal',
    'boxplot_high': 'máximo',
    'boxplot_low': 'mínimo',
    'boxplot_median': 'mediana',
    'boxplot_q1': 'Q1',
    'boxplot_q3': 'Q3',
    'brazilian_holstein_cattle_association': 'Associação Brasileira Gado Holandês (ABCBRH)',
    'break': 'quebra',
    'breathing': 'respiração',
    'breathing_status_changed': 'status respiratório alterado',
    'brix': 'brix',
    'browser_guard_benefits': 'Manter o navegador atualizado ajuda a garantir mais segurança, melhor desempenho e o funcionamento correto de todas as funcionalidades disponíveis.',
    'browser_guard_benefits_mac': 'O Safari é atualizado junto com o macOS, por isso a atualização precisa ser feita pelo sistema. Se preferir, você também pode acessar o sistema por outro navegador, como Chrome, Edge, Firefox ou Opera.',
    'browser_guard_confirm_checkbox': 'Declaro estar ciente de que a versão do meu navegador não é compatível com a versão mínima recomendada e que isso pode causar erros ou comportamentos inesperados.',
    'browser_guard_download_tooltip': 'Ir para a página de download do {browser}',
    'browser_guard_eyebrow': 'Atualização necessária',
    'browser_guard_footer': 'Atualize seu navegador para a versão mais recente e recarregue esta página. Se preferir, você também pode acessar o sistema utilizando outro navegador.',
    'browser_guard_footer_feature': 'Para continuar, acesse o sistema por um navegador atualizado, como Chrome, Edge, Firefox ou Opera.',
    'browser_guard_footer_ios': 'Para atualizar, abra Ajustes > Geral > Atualização de Software e instale a versão mais recente disponível. Depois, volte para esta página e tente novamente.',
    'browser_guard_footer_mac': 'Para atualizar, abra Ajustes do Sistema > Geral > Atualização de Software e instale a versão mais recente disponível. Depois, volte para esta página e tente novamente.',
    'browser_guard_installed_version_label': 'Versão instalada',
    'browser_guard_message': 'Identificamos que você está utilizando o {detectedBrowser}, que está abaixo da versão mínima suportada ({minimumBrowser}) para este sistema.',
    'browser_guard_message_feature': 'Identificamos que você está utilizando o {detectedBrowser}, que não é compatível com os recursos necessários para este sistema.',
    'browser_guard_message_ios': 'O sistema do seu aparelho está desatualizado e não é compatível com esta página. Para continuar usando o sistema CowMed, atualize o seu iPhone ou iPad para o {minimumBrowser} ou mais recente.',
    'browser_guard_message_mac': 'O Safari do seu Mac está desatualizado e não é compatível com esta página. Para continuar usando o sistema CowMed, atualize o macOS para obter o {minimumBrowser} ou mais recente.',
    'browser_guard_proceed_button': 'Avançar',
    'browser_guard_title': 'Seu navegador precisa ser atualizado',
    'browser_guard_title_feature': 'Seu navegador não é compatível',
    'browser_guard_title_ios': 'Seu iPhone ou iPad precisa ser atualizado',
    'browser_guard_title_mac': 'Seu Safari precisa ser atualizado',
    'browser_guard_update_ios_tooltip': 'Ver como atualizar o iOS',
    'browser_guard_update_mac_tooltip': 'Ver como atualizar o Safari',
    'bull_losses': 'perdas por touro',
    'bull_migration': 'Migração de touros',
    'bull_or_semen': 'Touro / Sêmen',
    'bull_or_semen_archive_message': 'O touro / sêmen não fica mais disponível para uso na fazenda:\n\n- Não pode mais ser utilizado como pai de um animal;\n- Não pode mais ser utilizado no registro de serviços;\n- Não pode mais ser utilizado no registro de acasalamentos;\n- Seus apelidos são removidos.\n\nTodo histórico é mantido e pode ser consultado a qualquer momento!',
    'bull_or_semen_migration_message': 'Temporariamente, os registros na fazenda devem continuar sendo feitos na lista antiga de Touro / Sêmen. A nova lista só passará a ser utilizada após a migração completa dos dados para a nova estrutura.',
    'bull_or_semen_remove_warning': 'ao remover, todo histórico relacionado a este touro/sêmen será apagado',
    'bunk_score': 'escore de cocho',
    'c_com': 'C-Com {item}',
    'c_com_communication_status': 'status de comunicação da C-com',
    'c_com_details': 'detalhes da c-com',
    'c_com_managment': 'gestão de antenas',
    'c_com_map': 'Mapa de status de c-com',
    'c_com_plural': 'C-Coms {item}',
    'c_com_primary': 'C-Coms primárias',
    'c_com_secondary': 'C-Coms secundárias',
    'c_com_status': 'status da c-com',
    'c_tech': 'C-Tech {item}',
    'caesarean_surgery': 'cesariana ou cirurgia',
    'calf': 'bezerra',
    'calf_condition': 'condição do bezerro(a)',
    'calf_plural_female': 'bezerras',
    'calf_unknown': 'bezerro(a)',
    'calvin_complication': 'o parto teve alguma complicação?',
    'calvin_estimate': 'previsão de parto',
    'calving': 'parto',
    'calving_dificulty': 'dificuldade do parto',
    'calving_event': 'evento de parto',
    'calving_event_plural': 'eventos de parto',
    'calving_interval': 'IEP',
    'calving_plural': 'partos',
    'calving_procedure': 'procedimento de parto',
    'calving_projection': 'projeção de partos',
    'camera_batches': 'câmeras',
    'campaign': 'campanha',
    'campaigns': 'campanhas',
    'cancel': 'cancelar',
    'cancel_item': 'cancelar {item}',
    'cancellation': 'cancelamento de contrato',
    'cancellation_reason': 'motivo do cancelamento',
    'cancellation_request': 'solicitação de cancelamento',
    'card_view': 'cards',
    'case': 'casos',
    'categories': 'categorias',
    'category': 'categoria',
    'ccom_list': 'lista de C-Com',
    'ccom_map': 'mapa de C-Com',
    'CCS_or_CBT': 'CCS / CBT',
    'challenge': 'desafio',
    'challenged_animals': 'animais em desafio',
    'change_animal': 'troca de animal',
    'change_collar_between_animals': 'troca de coleira entre animais',
    'change_collars': 'troca de coleiras',
    'change_cow_comfort_between_points': 'troca de CowComfort entre pontos',
    'change_group': 'troca de Lote',
    'change_group_plural': 'troca de lotes',
    'change_image': 'alterar imagem',
    'change_of_item': 'troca de {item}',
    'change_password': 'alterar senha',
    'change_password_confirmation': 'Um email com instruções de renovação de senha será enviado para o usuário {userName} ({userEmail}). Deseja confirmar a ação?',
    'change_to_heifer': 'mudança para novilha',
    'charged': 'carregada',
    'charger_active': 'carregador',
    'charging': 'carregando',
    'chart_type_column': 'alterar para gráficos de colunas',
    'chart_type_line': 'alterar para gráficos de linhas',
    'chart_type_restore': 'restaurar gráfico',
    'chat_deleted_successfully': 'chat deletado com sucesso!',
    'chat_plural': 'chats',
    'check_all_as_read': 'Marcar todos como lido',
    'check_as_read': 'marcar como lido(s)',
    'choose_field': 'escolher campo',
    'city': 'cidade',
    'clear': 'limpar',
    'client': 'cliente',
    'clinical_opinion': 'parecer clínico',
    'close': 'fechar',
    'closure_by': 'encerramento por',
    'collar': 'coleira {item}',
    'collar_down_sell': 'down sell',
    'collar_event_received_at': 'transmissão da C-Com',
    'collar_interval': 'intervalo de coleiras',
    'collar_link': 'vínculo da coleira',
    'collar_managment': 'gestão de coleira',
    'collar_managment_plural': 'gestão de coleiras',
    'collar_map': 'mapa de report de coleira',
    'collar_plural': 'coleiras {item}',
    'collar_status': 'status da coleira',
    'collar_up_sell': 'up sell',
    'collected_milk': 'leite coletado',
    'collection': 'coleta',
    'colostration': 'colostragem',
    'colostrum_type': 'tipo de colostro',
    'column_order': 'ordem das colunas',
    'comfortable': 'confortável',
    'comment': 'comentário',
    'comment_plural': 'comentários',
    'commercial_condition_description': 'descrição da condição comercial',
    'commercial_products': 'produtos comerciais',
    'common_status': 'status comum',
    'communication_abbreviation': 'com.',
    'communications': 'comunicações',
    'compact': 'compacto',
    'company': 'empresa',
    'company_answers': 'respostas empresas',
    'company_contacts': 'contatos da empresa',
    'company_plural': 'empresas',
    'compare_with': 'comparar com',
    'complement': 'complemento',
    'concentrate': 'concentrado',
    'conception': 'concepção',
    'conception_per_DEL': 'concepção por DEL',
    'conception_rate': 'taxa de concepção',
    'condition': 'condição',
    'config_item': 'configurar {item}',
    'configured_by_cowmed_team': 'configurada pelo time CowMed',
    'confirm_item': 'confirmar {item}',
    'confirmation': '{item} confirmação',
    'confirmation_of_item': 'confirmação de {item}',
    'confirmed_at': 'confirmado em',
    'confirmed_by': 'confirmado por',
    'confirmed_plural': 'confirmados',
    'connect': 'conectar',
    'connected': 'conectada',
    'connected_services': 'serviços conectados',
    'connectivity': 'conectividade',
    'contract': 'contrato',
    'contract_address': 'endereço (contrato)',
    'contract_first_payment': 'primeiro pagamento',
    'contract_plural': 'contratos',
    'contract_start_date': 'data de início do contrato',
    'contract_summary': 'resumo de contrato',
    'contracted_plan': 'plano contratado',
    'cookie_consent': 'Utilizamos cookies para avaliar e analisar o uso dos recursos do software, visando o seu aperfeiçoamento e melhoria da experiência do usuário. Ao concordar, você nos autoriza a coletar e usar essas informações. Obrigado pela contribuição.',
    'coordinates': 'coordenadas',
    'copied_text_successfully': 'texto copiado para a área de transferência',
    'copy': 'copiar',
    'copy_all': 'copiar todos',
    'copy_unprocessed': 'copiar ids não processados',
    'corporate_name': 'razão social',
    'correct_item': 'corrigir {item}',
    'country': 'país',
    'cow_analytics': 'cow analytics',
    'cow_analytics_calving_text': 'Vacas prenhes próximas à data de parto, atualmente na fase de pré-parto',
    'cow_analytics_conception_text': 'Análise da eficiência dos serviços da fazenda',
    'cow_analytics_discard_text': 'Taxa de descarte e análise dos motivos de descarte',
    'cow_analytics_drying_text': 'Vacas prenhes próximas à data de secagem',
    'cow_analytics_gestational_loss_text': 'Analise as perdas embrionárias e fetais na gestação',
    'cow_analytics_health_text': 'Analise os resultados das boas práticas sanitárias da sua fazenda',
    'cow_analytics_heat_monitoring_text': 'Eficiência da detecção de cio e o aproveitamento dos alertas na fazenda',
    'cow_analytics_heat_return_text': 'Animais que estão próximos ao período de retorno de cio',
    'cow_analytics_marked_as': 'animais marcados como: descarte, indução, inapta e protocolo',
    'cow_analytics_milk_control_text': 'acompanhe a produção e a qualidade do leite do rebanho',
    'cow_analytics_pre_calving_prediction_text': 'Vacas prenhes próximas à entrada no pré-parto',
    'cow_analytics_pregnancy_diagnosis_text': 'Vacas atrasadas que aguardam diagnóstico de prenhez',
    'cow_analytics_rearing_text': 'Avalie o desenvolvimento dos animais jovens da sua fazenda',
    'cow_analytics_services_text': 'Análise dos serviços realizados na fazenda',
    'cow_analytics_transition_text': 'Análises e relatórios referentes ao período de transição',
    'cow_analytics_wellness_text': 'Avalie o estado de conforto térmico, descanso e consumo dos seus animais',
    'cow_baby': 'CowBaby',
    'cow_comfort': 'CowComfort {item}',
    'cow_comfort_managment': 'gestão de CowComfort',
    'cow_connect': 'CowConnect',
    'cow_plural': 'vacas {item}',
    'cowbaby_expired': 'Baby expirada',
    'cowconnect_payment_start': 'contrato CowConnect',
    'cowsync': 'cowsync',
    'create_item': 'cadastrar {item}',
    'created_at': 'criado em',
    'created_by': 'criado por',
    'created_item_at': '{item} Criado em',
    'critical': 'grave',
    'critical_dim_without_pregnancy': 'Del alto sem prenhez',
    'crop': 'recortar',
    'cross_sell_cowconnect_plan': 'cross sell para CowConnect',
    'cross_sell_monitoring_plan': 'cross sell para CowMed Monitoramento',
    'cs': 'CS',
    'ctech_possible_removal_message': 'Estas coleiras estão vinculadas a animais, mas sem atividade registrada, possivelmente removidas ou perdidas. Verifique e atualize o vínculo ou contate o suporte CowMed.',
    'ctech_waiting_attachment_message': 'estas coleiras estão em perfeitas condições de funcionamento, porém estão instaladas em um animal que ainda não foi informado ao sistema.',
    'current_farm_entry': 'entrada na fazenda atual',
    'custom_list': 'lista personalizada',
    'customer_center': 'central do cliente',
    'customization': 'personalização',
    'cycle': 'ciclo',
    'cycling_rate': 'cycling rate',
    'cycling_rate_accumulated': 'cycling rate acumulado',
    'daily_behavior_slash_production': 'comportamento diário / produção',
    'daily_meals': 'refeições diárias',
    'dashboard': 'dashboard',
    'data': 'dado',
    'data_from_date': 'dados de {date}',
    'data_interval': 'intervalo de dados',
    'data_interval_per_batch': 'intervalo de dados por lote',
    'data_not_recognized': 'dados não reconhecidos',
    'data_plural': 'dados',
    'data_stack_max_percentage': 'porcentagem máxima da pilha de dados',
    'data_to_be_processed': 'dados a serem processados',
    'data_update': 'atualização de dados',
    'data_view': 'data view',
    'data_view_benchmarking_text': 'Confira o ranking de desempenho das fazendas monitoradas pela Cowmed',
    'data_view_contracts_text': 'análise operacional de contas e contratos',
    'data_view_contracts_title': 'contas e contratos',
    'datagrid_actions': 'ação',
    'datagrid_config_message': 'as configurações definidas nesta seção são aplicadas apenas localmente no seu navegador. Elas não afetam a exportação dos dados, servindo apenas para facilitar a visualização da tabela.',
    'datagrid_config_title': 'importante',
    'datagrid_records_info': 'registro {from} a {to} de {total}',
    'datagrid_results_per_page': 'resultados por página:',
    'datatable_no_records_found': 'nenhum registro encontrado',
    'date': 'data',
    'date_after_maximal': 'A data não deve ser depois da data máxima',
    'date_before_minimal': 'A data não deve ser antes da data mínima',
    'date_format_long': 'DD/MM/YYYY',
    'date_format_long_timestamped': 'DD/MM/YYYY HH:mm',
    'date_milk_production': 'Data da produção leiteira',
    'date_of_marking': 'data da marcação',
    'datepicker_last_days': 'últimos {days} dias',
    'datepicker_previous_month': 'mês passado',
    'day': 'dia',
    'day_monitoring': 'monitoramento dia',
    'days': 'dias',
    'days_open': 'dias em aberto',
    'DEA': 'DEA',
    'deactivate': 'desativar',
    'death_method': 'método de descarte',
    'default': 'padrão',
    'default_values': 'valores iniciais',
    'DEL': 'DEL',
    'DEL_long_text': 'dias em lactação',
    'delay_ccom_legend': 'dados referentes ao primeiro status da hora',
    'delay_legend': 'escala de cores de acordo com o atraso no envio de dados:',
    'delete_inapt': 'Ao desfazer esta marcação a vaca passa a ser considerada apta durante o período da marcação. Este registro serve para corrigir erros de marcação. Se você deseja apenas liberar esta vaca a partir de hoje e torná-la apta, sugerimos registrar o evento "desmarcar como".',
    'delete_inapt_message': 'Você tem certeza que deseja remover a marcação?',
    'delete_permanently': 'excluir definitivamente',
    'deleted_at': '{item} removido em',
    'delivery_address': 'endereço de entrega',
    'departure_kind': 'tipo de saída',
    'departure_reason': 'motivo de saída',
    'dependent': 'dependente',
    'description': 'descrição',
    'designed_by': 'projetado por',
    'desynchronized': 'dessincronizada',
    'detach_collar': 'desvincular coleira',
    'detach_item': 'desvincular {item}',
    'detached_collar': 'coleira desvinculada',
    'details': 'detalhes',
    'detected': 'detectado {item}',
    'detected_at': '{item} detectado em',
    'detection_method': 'método de detecção',
    'developer_mode': 'modo desenvolvedor',
    'developer_mode_description': 'recursos para desenvolvimento',
    'device_label': 'dispositivo',
    'device_list': 'lista de dispositivos',
    'device_renewal': 'renovação do dispositivos',
    'device_status': 'status do dispositivo',
    'device_status_plural': 'status dos dispositivos',
    'diagnosed_animals': 'animais diagnosticados',
    'diagnostic': 'diagnóstico',
    'diagnostic_plural': 'diagnósticos',
    'did_the_animal_exhibit_any_abnormal_behavior': 'o animal apresentou algum comportamento anormal?',
    'diet_handling': 'trato',
    'diet_initials': 'D',
    'diet_label': 'dieta',
    'diet_setup': 'cadastro de dieta',
    'difference_between_minimum_maximum': 'diferença entre índice mínimo e máximo',
    'difficult_assistance': 'difícil (com assistência)',
    'difficult_vet_care': 'difícil (assistência veterinária)',
    'dim_first_service_dispersion': 'dispersão 1º serviço',
    'dim_losses': 'perdas por del',
    'DIM_on_first_service': 'DEL no 1º serviço',
    'DIM_on_first_service_help_message': 'Apresenta os dias em lactação no momento do primeiro serviço dos animais e a eficiência na concepção. Considera apenas serviços realizados após 30 dias, garantindo o tempo mínimo necessário para diagnóstico de prenhez.',
    'discard': 'descartar',
    'discard_collar': 'descartar coleira',
    'discard_cow_comfort': 'descartar CowComfort',
    'discard_moment': 'Momento do Descarte',
    'discard_out': 'descarte / saída',
    'discard_plural': 'descartes',
    'discard_rate': 'taxa de descarte',
    'discard_reason': 'motivo de descarte',
    'discard_register': 'registro de descarte/venda/exclusão',
    'discard_total': 'total de descarte',
    'discarded_animals': 'animais descartados',
    'discarded_or_deleted': '{item} descartado/deletado',
    'disconnect': 'desconectar',
    'disconnect_integration_alert': 'as configurações da integração serão apagadas e precisarão ser informadas novamente para conectar.',
    'disconnected': 'desconectadas',
    'disconnected_singular': 'desconectada',
    'dnd_drag_animals_to_batch': 'para adicionar animais ao lote, arraste-os para esta coluna',
    'dnd_drag_to_column': 'arraste itens para esta coluna',
    'dnd_drag_to_define_order': 'arraste os campos para definir a ordem de exibição na tabela',
    'do_you_really_want_to_item': 'você realmente deseja {item} {id}?',
    'do_you_really_want_to_reverse_archive_item': 'tem certeza que deseja reverter a arquivação do {item} {id}?',
    'do_you_really_want_to_revert_this_application': 'tem certeza que deseja reverter esta aplicação?',
    'document_date_format': 'formato da data do documento',
    'donor': 'doadora',
    'donor_plural': 'doadoras',
    'download': 'baixar',
    'download_app': 'baixar o app Cowmed',
    'download_file': 'baixar arquivo',
    'download_pdf': 'baixar arquivo PDF',
    'download_png': 'baixar imagem PNG',
    'download_results': 'baixar resultados',
    'download_spreadsheet': 'baixar planilha {item}',
    'download_template_spreadsheet': 'faça o download da planilha modelo',
    'download_xls': 'baixar arquivo XLS',
    'dry': 'seca',
    'dry_event_plural': 'eventos de secagem',
    'dry_reason': 'motivo da secagem',
    'drying': 'secagem',
    'drying_projection': 'projeção de secagens',
    'DTR_initials': 'DTR',
    'DUI_long_text': 'dias da última inseminação',
    'duplicate_item': 'duplicar {item}',
    'duplicate_role': 'duplicar papel',
    'easy_unassisted': 'fácil (assistida)',
    'edit_farm_bull_link': 'editar apontamento',
    'edit_personal_info': 'editar informações pessoais',
    'ein': 'CNPJ',
    'eligible_cow_plural': 'vacas aptas',
    'email': 'e-mail',
    'embryo_transfer': 'transferência embrionária',
    'embryo_type': 'tipo de embrião',
    'empty': 'vazia',
    'empty_animal': 'animal vazio',
    'empty_farm_profile_msg': 'Ops! Parece que você ainda não cadastrou o perfil desta fazenda!',
    'empty_list': 'lista vazia',
    'empty_male': 'vazio',
    'empty_time': 'tempo vazio',
    'empty-post-delivery': 'vazia PEV',
    'end_date': 'data final',
    'end_of_item_withdrawal': 'fim da carência de {item}',
    'end_of_messages': 'fim das mensagens',
    'engagement': 'engajamento',
    'environmental_comfort': 'análise do THI',
    'error_500': 'Um erro ocorreu. Desculpe o transtorno. Se o problema persistir, envie um e-mail para software@cowmed.com.br indicando qual ação realizada ocasionou este erro.',
    'error_deleting_chat': 'erro ao deletar o chat',
    'error_maintenance': 'erro/manutenção',
    'error_plural': 'erros',
    'error_sending_feedback': 'Aconteceu um erro ao enviar seu feedback!',
    'ET': 'TE',
    'et-hormone-implanted': 'IH-TETF',
    'evaluation_date': 'data de avaliação',
    'event': 'evento',
    'event_of_plural': 'eventos de {item}',
    'event_plural': 'eventos',
    'exit_fullscreen': 'sair da tela cheia',
    'exitFullscreen': 'sair do modo de tela cheia',
    'export': 'exportar {item}',
    'export_data': 'exportar dados',
    'exportable': 'exportável',
    'exportation': 'exportação',
    'exporting': 'exportando...',
    'exports': 'exportações',
    'extra_modules': 'módulos extras',
    'failed': 'falha na execução',
    'farm': 'fazenda',
    'farm_account_plural': 'contas fazenda',
    'farm_address': 'endereço da fazenda',
    'farm_answers': 'respostas fazendas',
    'farm_code': 'código da fazenda',
    'farm_contract_plural': 'contratos da fazenda',
    'farm_database': 'farm database',
    'farm_distribution': 'distribuição em fazenda',
    'farm_list': 'listar fazendas',
    'farm_list_description': 'fazendas disponíveis para você',
    'farm_management': 'manejo da fazenda',
    'farm_name': 'nome da fazenda',
    'farm_OKR': 'OKR',
    'farm_plural': 'fazendas',
    'farm_profile': 'Perfil da fazenda',
    'farm_revision': 'revisão na fazenda',
    'farm_settings': 'configurações da fazenda',
    'farm_settings_description': 'rede, OKR, usuários e mais',
    'farms_without_portfolio': 'fazendas sem carteira',
    'fat_percentage': 'gordura (%)',
    'feed': 'trato',
    'female': 'fêmea',
    'fidelity': 'fidelidade',
    'field': 'campo',
    'file': 'arquivo',
    'files': 'arquivos',
    'fill_all_required_fields': 'preencha todos os campos solicitados',
    'filter': 'filtro',
    'final_value': 'valor final',
    'financing_modality': 'modalidade de financiamento',
    'find_by_item': 'pesquise por {item}',
    'find_item': 'localizar {item}',
    'finish': 'concluir',
    'finished_at': 'finalizado em',
    'fixed': 'fixas',
    'foetus': 'sexagem',
    'for_discard': 'para descarte',
    'for_induction_lactation': 'para indução de lactação',
    'for_protocol': 'para protocolo',
    'forecast_return': 'previsão de retorno',
    'form_with_errors': 'Ops! Encontramos alguns erros no formulário. Corrija os campos destacados para seguir com o cadastro.',
    'formbuilder_error_fetching_data_message': 'Não foi possível carregar o formulário no momento. Tente novamente em alguns instantes. Se o problema persistir, entre em contato com nossa equipe para que possamos ajudar o mais rápido possível.',
    'formbuilder_error_fetching_data_title': 'Erro ao carregar o formulário',
    'full': 'cheio',
    'full_screen': 'ver em tela cheia',
    'fullscreen': 'ver em tela cheia',
    'gender': 'sexo',
    'general': 'geral',
    'general_farm': 'geral da fazenda',
    'general_herd': 'rebanho geral',
    'general_info_plural': 'informações gerais',
    'general_milk_control': 'controle leiteiro geral',
    'general_production': 'produção geral',
    'general_spreadsheet': 'planilha geral',
    'general_status': 'status geral',
    'general_wellness': 'bem-estar geral',
    'gestational_loss': 'perdas gestacionais',
    'global_search': 'Pesquisável por: Animal, Lote, Coleira e Página',
    'global_search_pages_and_farms': 'Pesquisável por: Fazenda e Página',
    'group_item': 'Grupo {number}',
    'growth_curve': 'curva de crescimento',
    'gynecologic_examination': 'exame ginecológico',
    'handling': 'manejo',
    'handling_events': 'eventos de manejo',
    'handling_register': 'registro de manejo',
    'health': 'saúde',
    'health_alert_plural': 'alerta de saúde',
    'health_event': 'evento de saúde',
    'health_event_plural': 'eventos de saúde',
    'health_protocols': 'protocolos sanitários',
    'health_status': 'status de saúde',
    'heat': 'cio',
    'heat_alert': 'alerta de cio',
    'heat_alert_plural': 'alertas de cio',
    'heat_detected': 'cios detectados',
    'heat_monitoring': 'monitoramento de cio',
    'heat_register_12_hours_before': 'registrar novo CIO (12 horas anteriores à inseminação',
    'heat_return': 'retorno de cio',
    'heat_strength': 'força do cio',
    'heat_type_iatf': 'IATF',
    'heifer': 'novilha',
    'help': 'ajuda',
    'help_center': 'central de ajuda',
    'help_us_understand_what_happened': 'nos ajude a entender o que aconteceu',
    'herd': 'rebanho',
    'herd_and_reproduction': 'rebanho + reprodução',
    'herd_and_reproduction_and_batches': 'rebanho + reprodução + lotes',
    'herd_and_reproduction_and_milk_control': 'rebanho + reprodução + controle leiteiro',
    'herd_cow_analytics_card_text': 'analise o seu rebanho, evolução e distribuição',
    'hexadecimal_key': 'chave hexadecimal',
    'hideData': 'esconder tabela de dados',
    'highcharts_events': 'visualização de eventos',
    'highcharts_export': 'exportar gráficos',
    'hint_register_farm_profile_msg': 'Comece a registrar o perfil clicando no botão abaixo.',
    'historic': 'histórico',
    'home': 'início',
    'hospital_time': 'tempo de enfermaria',
    'hour_initials_plural': 'hrs',
    'hourly': 'hora/hora',
    'hourly_monitoring': 'monitoramento hora',
    'hours_over_limit': 'horas acima do limite',
    'how_to_use': 'modo de uso',
    'humidity': 'umidade',
    'i_got_it': 'Ok, Entendi',
    'ia_cob_te': 'IA/COB/TE',
    'identification': 'identificação',
    'ignore_temporarily': 'ignorar temporariamente',
    'ignore_temporarily_alert_message': 'ao marcar um animal como "Ignorado temporariamente", ele será removido da lista da enfermaria por 12 horas. Durante este período, caso haja alteração no status, no diagnóstico ou no tratamento, o animal retornará automaticamente à lista.',
    'ignore_temporarily_confirm_message': 'você tem certeza que deseja ignorar temporariamente esse animal?',
    'image_load_error': 'Não foi possível carregar a imagem',
    'implant_lost_initials': 'PI',
    'import': 'importação',
    'import_data': 'importar dados',
    'import_details': 'detalhes da importação',
    'import_discards': 'importar descartes',
    'import_item': 'importar {item}',
    'import_will_be_notified': 'Clique em Importar. Ao fim do processamento você será notificado.',
    'imports': 'importações',
    'in_cancellation': 'em cancelamento',
    'inactive_female': 'inativa',
    'inactive_male': 'inativo',
    'inactive_time': 'tempo de inatividade',
    'inapt_for_reproduction': 'inapta para reprodução',
    'included_products': 'produtos inclusos',
    'index': 'índice {item}',
    'individual_milk_control': 'controle leiteiro individual',
    'individual_production': 'produção individual',
    'induced_lactation': 'lactação induzida',
    'induction': 'indução',
    'inductions_realized': 'induções realizadas',
    'ineligible_heifer_plural': 'novilhas inaptas',
    'infirmary': 'enfermaria',
    'info_short': 'info',
    'information_plural': 'informações',
    'ingredient': 'insumo',
    'ingredient_management': 'gestão de insumos',
    'initial_value': 'valor inicial',
    'inseminated': 'inseminada',
    'inseminated_plural': 'inseminadas',
    'insemination': 'inseminação',
    'inseminator': 'inseminador',
    'installed_by': 'instalado por',
    'intake_and_panting': 'consumo e ofegação',
    'intake_and_rumination': 'consumo e ruminação',
    'integrations': 'integrações',
    'integrations_description': 'parceiros e serviços conectados à fazenda',
    'intelligence_parameters': 'parâmetros de inteligência',
    'intensity': 'intensidade',
    'interaction': 'interação',
    'international_register': 'registro internacional',
    'interval': 'intervalo',
    'interval_between_services': 'intervalo entre serviços',
    'invalid_date_format': 'formato de data inválido',
    'invalid_field': 'o campo "{item}" é inválido',
    'invalid_image_file': 'o arquivo selecionado não é uma imagem',
    'invalid_latitude': 'Latitude inválida. Deve estar entre -90 e 90.',
    'invalid_longitude': 'Longitude inválida. Deve estar entre -180 e 180.',
    'inventory': 'inventário',
    'is_operating': 'está operando',
    'item_count_plural': '{item} itens',
    'item_history': 'histórico de {item}',
    'item_index': 'índice de {item}',
    'item_lat_lng_invalid': '{item} possui configuração de latitude/longitude inválida.',
    'item_limit_of': 'de {max} (limite)',
    'item_limits': 'limites de itens',
    'item_monitored_plural': '{item} monitorados',
    'item_selected_plural': '{item} selecionados',
    'item_withdrawal': 'carência de {item}',
    'lactating_animals': 'animais em lactação',
    'lactation': 'lactação',
    'lactation_induction': 'indução de lactação',
    'lactation_plural': 'lactações',
    'lactose_percentage': 'Lactose (%)',
    'language': 'idioma',
    'last_ai': 'última IA',
    'last_calving': 'último parto',
    'last_cloud_sync': 'última sincronização com a nuvem',
    'last_confirmation': 'última confirmação',
    'last_connection': 'última conexão',
    'last_feed': 'último trato',
    'last_insemination': 'Quando foi a última inseminação da vaca...',
    'last_link': 'último vínculo',
    'last_processed_at': 'processado pela última vez em',
    'last_read': 'última leitura',
    'last_report': 'último reporte',
    'last_request': 'última requisição',
    'last_status': 'último status',
    'last_update': 'última atualização',
    'late_inseminated': 'inseminadas atrasadas',
    'late-inseminated': 'inseminadas atrasadas',
    'latest_evaluation': 'última avaliação',
    'latitude': 'latitude',
    'lead_time_cm': 'lead time CM',
    'leisure': 'ócio',
    'less_details': 'menos detalhes',
    'limit': 'limite',
    'link_to_farm_bull': 'apontar para touro da fazenda',
    'linked_to_farm_bull': 'apontado para touro da fazenda',
    'list_view': 'lista',
    'lists': 'listas',
    'load_more': 'carregar mais',
    'loading': 'carregando',
    'loading_animal_info': 'carregando informações do animal',
    'loading_batch_info': 'carregando informações do lote',
    'loading_ccom_info': 'carregando informações da CCom',
    'loading_cenv_info': 'carregando informações do cowcomfort',
    'loading_chart_data': 'carregando dados do gráfico...',
    'loading_company_info': 'carregando informações da empresa',
    'loading_ctech_info': 'carregando informações da coleira',
    'loading_farm_info': 'carregando informações da fazenda',
    'loading_import_details': 'carregando detalhes da importação',
    'loading_just_a_moment': 'Aguarde um momento. Carregando...',
    'loading_list_info': 'carregando informações da lista',
    'loading_permission_farm': 'carregando permissões da fazenda',
    'loading_production_info': 'carregando informações da produção',
    'loading_protocol_info': 'carregando informações do protocolo',
    'loading_semen_info': 'carregando informações do touro/sêmen',
    'loading_thi_info': 'carregando informações de THI',
    'loading_user_info': 'carregando informações do usuário',
    'loading_wait_a_moment': 'aguarde um momento',
    'location': 'localização',
    'location_map': 'mapa de localização',
    'logout': 'sair',
    'longitude': 'longitude',
    'loss_rate': 'taxa de perdas',
    'lost_female_plural': 'perdidas',
    'low': 'baixo',
    'mac_address': 'MAC',
    'maintenance_plural': 'manutenções',
    'male': 'macho',
    'mammary_quarter': 'quarto mamário',
    'manage_account': 'Gerenciar conta',
    'manage_account_and_password': 'gerenciar conta e senhas',
    'manage_item': 'gerenciar {item}',
    'manage_password_and_access': 'gerencie a senha e as sessões da sua conta',
    'manage_points': 'gerenciar pontos',
    'management_system': 'sistema de manejo',
    'manufacturer': 'fabricante',
    'manufacturer_plural': 'fabricantes',
    'mark': 'marcar',
    'mark_as_item': 'marcar como {item}',
    'mark_as_not_applied_bulk_warning': 'você tem certeza que deseja marcar como não aplicadas?',
    'mark_as_not_applied_warning': 'você tem certeza que deseja marcar como não aplicada?',
    'marked_as': 'marcadas como',
    'marked_as_unfit': 'marcada como inapta à reprodução',
    'marked_for_discard': 'marcada para descarte',
    'marked_for_induction': 'marcada para indução de lactação',
    'marked_for_induction_plural': 'marcados para indução',
    'marked_for_protocol': 'marcada para protocolo',
    'marked_for_protocol_plural': 'marcadas para protocolo',
    'marking': 'marcação',
    'mastitis': 'mastite',
    'mastitis_causative_agent': 'agente causador',
    'mastitis_dynamics': 'dinâmica de mastite',
    'mastitis_history': 'histórico de mastite',
    'mastitis_intensity_level': 'grau de intensidade',
    'mating': 'Acasalamento',
    'matrix': 'matriz',
    'matrix_plural': 'matrizes',
    'meals': 'refeições',
    'meat': 'carne',
    'medication': 'medicamento',
    'mild_to_moderate_stress': 'estresse leve a moderado',
    'milk': 'leite',
    'milk_control': 'controle leiteiro',
    'milk_control_and_batches': 'controle leiteiro + lotes',
    'milk_production': 'produção leiteira',
    'milk_production_date': 'informe a data do controle leiteiro que deseja importar. Serão processados apenas os registros desta data.',
    'milking_item': 'ordenha {item}',
    'minute_initials': 'min',
    'model': 'modelo',
    'model_protocol': 'modelo de protocolo',
    'moderated': 'moderado',
    'module_permissions': 'permissões do módulo',
    'module_plural': 'módulos',
    'monitored_plural': 'monitorados',
    'monitored_points': 'pontos monitorados',
    'monitoring': 'monitoramento',
    'monitoring_activation': 'ativação de monitoramento',
    'monitoring_contract': 'contrato monitoramento',
    'monitoring_data': 'dados de monitoramento',
    'monitoring_point': 'ponto de monitoramento',
    'month': 'mês',
    'monthly_losses': 'perdas mensais',
    'months_april': 'abril',
    'months_august': 'agosto',
    'months_december': 'dezembro',
    'months_february': 'fevereiro',
    'months_january': 'janeiro',
    'months_july': 'julho',
    'months_june': 'junho',
    'months_march': 'março',
    'months_may': 'maio',
    'months_november': 'novembro',
    'months_october': 'outubro',
    'months_september': 'setembro',
    'more': 'Saiba mais',
    'more_animals': 'mais {count} animais',
    'more_details': 'mais detalhes',
    'more_information': 'mais informações',
    'mortality': 'mortalidade',
    'most_accessed': 'mais acessados',
    'move_collar_to': 'mover a coleira {item} para {location}',
    'move_cow_comfort_to': 'mover a CowComfort {item} para {location}',
    'move_to': 'mover para {location}',
    'moved': 'movimentadas',
    'multiparous': 'multíparas',
    'multiselect_item': 'Você selecionou {quantity} item da sua lista (até {max} itens).',
    'multiselect_item_plural': 'Você selecionou {quantity} itens da sua lista (até {max} itens).',
    'multiselect_register': 'Clique no menu opções para registrar vários eventos simultaneamente.',
    'my_protocols': 'meus protocolos',
    'n_days': '{days} dias',
    'name': 'nome',
    'national_register': 'registro nacional',
    'natural_mating': 'monta natural',
    'navel_cure': 'cura do umbigo',
    'negotiated_condition': 'condição negociada',
    'network': 'rede',
    'new_attach': 'novo vínculo',
    'new_chat': 'novo chat',
    'new_conversation': 'nova conversa',
    'new_item_female': 'nova {item}',
    'new_item_female_plural': 'novas {item}',
    'new_item_male': 'novo {item}',
    'next': 'próximo',
    'no': 'não',
    'no_active_integrations': 'você não possui nenhuma integração ativa',
    'no_available_integrations': 'você não possui nenhuma integração disponível',
    'no_collar': 'sem coleira',
    'no_data': 'sem dados',
    'no_data_after_hours': 'sem dados a mais de {hours} horas',
    'no_data_between_hours': 'sem dados entre as últimas {from} a {to} horas',
    'no_data_to_view': 'sem dados para visualizar',
    'no_item_limit': 'sem limite de itens',
    'no_leading_zeros_in_day': 'sem zeros à esquerda no dia',
    'no_leading_zeros_in_month': 'sem zeros à esquerda no mês',
    'no_limit': 'sem limite',
    'no_location_registered': 'nenhuma localização cadastrada',
    'no_messages_to_show': 'sem mensagens a exibir',
    'no_processed_data': 'dados não processados',
    'no_reported_data': 'sem dados reportados',
    'no_results_found': 'nenhum resultado encontrado.',
    'no_service': 'sem serviço',
    'normal': 'normal',
    'normalize_item': 'normalizar {item}',
    'not_applied': 'não aplicada',
    'not_applied_plural': 'não aplicadas',
    'not_moved': 'não movimentadas',
    'not_release': 'não liberar',
    'note': 'nota',
    'note_plural': 'notas',
    'notification_plural': 'notificações',
    'notification_settings_description': 'configure o recebimento de notificações',
    'nps': 'nps',
    'nps_reason_text': 'o que te motivou a dar essa nota?',
    'nps_score_text': 'em uma escala de 0 a 10, quanto você indicaria a CowMed?',
    'nps_subtitle': 'queremos sempre garantir a melhor experiência para você!',
    'nps_title': 'a Vic quer saber a sua opinião!',
    'number': 'número',
    'number_of_services': 'número de serviços',
    'nutrition': 'nutrição',
    'nutrition_and_intake': 'nutrição e consumo',
    'observation': 'observação',
    'of_day': 'do dia',
    'of_week': 'dos últimos 7 dias',
    'offline': 'offline',
    'op_between': 'entre',
    'op_equal': 'igual a',
    'op_greater': 'maior que',
    'op_less': 'menor que',
    'op_not_equal': 'diferente de',
    'open_animal_plural': 'animais vazios',
    'open_apt_heifers': 'vazias aos 15 meses',
    'open_c_com_managment': 'Abrir gestão de antenas',
    'operational': 'operacional',
    'operational_status': 'status operacional',
    'operator': 'operador',
    'opportunities': 'oportunidades',
    'option': 'opção',
    'option_plural': 'opções',
    'optional': 'opcional',
    'or': 'ou',
    'order_date': 'data do pedido',
    'ordering': 'ordenação',
    'other': 'outro',
    'other_information': 'outras informações',
    'other_software': 'Outros Softwares',
    'others': 'outros',
    'outdated_version_warning': 'você está utilizando uma versão desatualizada do COWMED. Para garantir o funcionamento correto do sistema e evitar erros ou inconsistências, a página será recarregada automaticamente em {seconds} segundos.',
    'overall_average': 'média geral',
    'overview': 'visão geral',
    'owner_name': 'nome do proprietário',
    'panting': 'ofegação',
    'panting_hours': 'horas ofegantes',
    'password': 'senha',
    'per_hour': 'por hora',
    'per_item': 'por {item}',
    'performed': 'realizados',
    'performed_female': 'realizada',
    'performeds_female': 'Realizadas',
    'permission': 'permissão',
    'permission_plural': 'permissões',
    'permissions_list': 'lista de permissões',
    'phone_number': 'telefone',
    'photo': 'foto',
    'please_try_again_contact_support': 'Por favor, tente novamente. Se o problema persistir, entre em contato com o suporte.',
    'point': 'ponto',
    'points': 'pontos',
    'portfolio': 'carteira',
    'portfolio_farms': 'fazendas da carteira',
    'possible_removal': 'possível remoção',
    'power_failure': 'falha de alimentação',
    'ppi': 'PPI',
    'ppi_animal': 'PPI Animal',
    'ppi_herd': 'PPI do rebanho',
    'pre_calving': 'pré-parto',
    'pre_calving_event': 'evento de pré-parto',
    'pre_calving_event_plural': 'eventos de pré-parto',
    'prediction_of': 'previsão de {item}',
    'predominant_breed': 'raça predominante',
    'pregnancy_diagnosis': 'diagnóstico de prenhez',
    'pregnancy_pre_calving': 'prenhe pré-parto',
    'pregnancy_rate': 'taxa de prenhez',
    'pregnant': 'prenhe',
    'pregnant-dry': 'prenhe seca',
    'pregnant-pre-delivery': 'pré-parto',
    'premature': 'prematuro',
    'previous_clinical_opinion': 'parecer clínico anterior',
    'previous_comment': 'comentário anterior',
    'primary': 'primária',
    'primary_plural': 'primárias',
    'primiparous': 'primíparas',
    'print': 'imprimir',
    'print_chart': 'imprimir gráfico',
    'printing': 'Gerando arquivo para impressão...',
    'problem_cows': 'Vacas problema',
    'processed_at': 'validado em',
    'processed_successfully': 'processado com sucesso',
    'processed_with_errors': 'processado com erros',
    'processing_information': 'analisando sua solicitação',
    'production': 'produção',
    'production_analysis': 'análise de produção',
    'production_details': 'detalhes da produção',
    'production_register': 'registro da produção',
    'production_slash_rumination': 'produção/ruminação',
    'production_total': 'produção total',
    'productive_ranking': 'ranking produtivo',
    'profile_and_intake': 'perfil e consumo',
    'programmed': 'programados',
    'project': 'projeto',
    'project_informations': 'informações do projeto',
    'project_type': 'tipo de projeto',
    'projection_lactating_cows': 'projeção de vacas em lactação',
    'projects': 'projetos',
    'prostaglandin': 'PG',
    'protein_percentage': 'Proteína (%)',
    'protocol': 'protocolo',
    'protocol_add_animal': 'adicionar animais ao protocolo',
    'protocol_details': 'detalhes do protocolo',
    'protocol_model_subtitle': 'Registre aqui as informações sobre os modelos de protocolo de IATF, TETF e PG.',
    'protocol_plural': 'protocolos',
    'protocol_remove_animal': 'remover animais do protocolo',
    'protocol_start': 'início do protocolo',
    'protocol_subtitle': 'Registre aqui as informações dos protocolos de IATF, TETF e PG',
    'protocoled_animals': 'animais protocolados',
    'PS': 'obs.',
    'push_up_needed': 'necessita empurra',
    'pushing': 'empurra',
    'quantity_supplied': 'quantidade fornecida',
    'quarter_abbreviation_left-back': 'PE',
    'quarter_abbreviation_left-front': 'AE',
    'quarter_abbreviation_right-back': 'PD',
    'quarter_abbreviation_right-front': 'AD',
    'quarter_description_left-back': 'posterior esquerdo',
    'quarter_description_left-front': 'anterior esquerdo',
    'quarter_description_right-back': 'posterior direito',
    'quarter_description_right-front': 'anterior direito',
    'queued': 'inicializado',
    'queued_at': 'enfileirado em',
    'quick_tip': 'dica rápida',
    'rag': 'RAG',
    'rags': 'RAGS',
    'raising_infirmary': 'enfermaria Baby',
    'reactivation_cowconnect': 'reativar CowConnect',
    'reactivation_monitoring': 'reativar monitoramento',
    'read_later': 'ver depois',
    'real_time': 'tempo real',
    'rearing_raising': 'Cria / Recria',
    'reason_text': 'motivo',
    'receiving_packages': 'recebimento de pacotes',
    'reception': 'recepção',
    'recommendation': 'recomendação',
    'recommended_hour': 'Horário recomendado expirado há {item} hora',
    'recommended_hour_plural': 'Horário recomendado expirado há {item} horas',
    'reconnected': 'reconectadas',
    'recover_this_register': 'recuperar este registro',
    'recovered': 'Recuperados',
    'recovered_event': 'evento recuperado',
    'redirect_timer': 'Em {time} {unit} você será redirecionado.',
    'redirecting_to_farm': 'redirecionando para a fazenda',
    'regional-station': 'estação regional',
    'register': 'registro',
    'register_another_swap': 'registrar outra troca',
    'register_item': 'registrar {item}',
    'register_item_updated_success_male': '{item} registrado/atualizado com sucesso',
    'register_more_details': 'desejo registrar mais detalhes',
    'register_new_animal': 'registrar novo animal',
    'registered_at_date': 'registrado em {date}',
    'registered_by': 'registrado por',
    'registered_losses': 'perdas registradas',
    'registration_data': 'dados cadastrais',
    'registration_of': 'cadastro de {item}',
    'reinstate_contract': 'reativação de contrato',
    'reject': 'rejeitar',
    'related_batches': 'lotes relacionados',
    'relationship': 'relacionamento',
    'relationship_type': 'Tipo de relação',
    'release': 'liberar',
    'release_notes': 'notas da versão',
    'release_to_reproduction': 'liberar para reprodução',
    'reload': 'recarregar',
    'remove_condition': 'remover condição',
    'remove_group': 'remover grupo',
    'remove_item': 'remover {item}',
    'remove_message': 'remover mensagem',
    'remove_rag': 'você realmente deseja remover RAG {item}?',
    'remove_row': 'remover linha',
    'remove_tokenized_animal': 'remover o animal da lista de animais tokenizados',
    'removed_animals': 'animais removidos',
    'removed_female': 'removida',
    'renewal_cowconnect': 'renovação CowConnect',
    'renewal_monitoring': 'renovação Monitoramento',
    'renewals': 'renovações',
    'replace': 'trocas',
    'replace_item': 'substituir {item}',
    'replace_records': 'corrigir registros',
    'replacement_rate': 'taxa de reposição',
    'replacement_request': 'requisição de troca',
    'replay_later': 'responder mais tarde',
    'report_cause_of_error': 'Para ajudar a nossa equipe, relate o que você fez para ocasionar esse erro.',
    'reported_at': 'reportado em',
    'reproduction': 'reprodução',
    'reproduction_event': 'evento de reprodução',
    'reproduction_event_plural': 'eventos de reprodução',
    'reproduction_event_this': 'este evento de reprodução',
    'reproduction_restriction': 'restrição de reprodução',
    'reproduction_status': 'status de reprodução',
    'reproductive_distribution': 'distribuição reprodutiva',
    'reproductive_evaluation': 'Avaliação reprodutiva',
    'reproductive_event_history': 'histórico de eventos reprodutivos',
    'reproductive_management': 'manejo reprodutivo',
    'reproductive_protocol': 'protocolo reprodutivo',
    'reproductive_protocols': 'protocolos reprodutivos',
    'required_field': 'esse campo é obrigatório',
    'reset_config': 'resetar configuração',
    'reset_item': 'resetar {item}',
    'reset_zoom': 'redefinir zoom',
    'resources': 'recursos',
    'response_error': 'ooops!',
    'response_info': 'informe!',
    'response_percentage': 'porcentagem de resposta',
    'response_success': 'sucesso!',
    'response_warning': 'atenção!',
    'responsible': 'responsável',
    'restart_time': 'tempo de reinicialização',
    'restore': 'restaurar',
    'restore_event': 'restaurar evento',
    'restore_item': 'restaurar {item}',
    'restore_this': 'restaurar este {item}',
    'results': 'resultados',
    'results_analysis': 'análise de resultados',
    'return_heats': 'cios de retorno',
    'revert_ignore_temporarily': 'reverter ignorar temporariamente',
    'revert_ignore_temporarily_confirm_message': 'você tem certeza que deseja reverter "Ignorar temporariamente" esse animal?',
    'revert_item': 'reverter {item}',
    'revision': 'revisão',
    'role': 'papel',
    'role_permissions': 'permissões do papel',
    'role_plural': 'papéis',
    'root': 'root',
    'row': 'linha',
    'row_index': 'índice',
    'rumination': 'ruminação',
    'rumination_max_index': 'índice máximo de ruminação',
    'rumination_min_index': 'índice mínimo de ruminação',
    'rumination_profile': 'perfil de ruminação',
    'sample': 'amostra',
    'sanitary-protocol': 'protocolo sanitário',
    'save': 'salvar',
    'save_config': 'salvar configuração',
    'save_file_in_format': 'salve o arquivo em formato "{format}"',
    'SBC_network_interface': 'interface de rede SBC',
    'SBC_status': 'status SBC',
    'SBC_version': 'versão SBC',
    'SBC_voltage': 'tensão SBC',
    'SCC_x1000': 'CCS (x1000)',
    'schedule_protocol': 'programação do protocolo',
    'scheduleds_female': 'programadas',
    'search': 'pesquisar',
    'search_back_to_all': 'voltar para todas as categorias',
    'search_filter_all': 'todos',
    'search_filter_pages': 'páginas',
    'search_in_the_menu': 'pesquise no menu...',
    'search_no_recent_example': 'experimente buscar por **animais**, **lotes**, **coleiras** ou **páginas**',
    'search_no_recent_title': 'nada por aqui ainda',
    'search_recent': 'recentes',
    'search_shortcut_navigate': 'navegar',
    'search_shortcut_open': 'abrir',
    'search_system_accesses_description': 'lista de fazendas',
    'secondary': 'secundária',
    'secondary_plural': 'secundárias',
    'security': 'segurança',
    'see_again': 'ver novamente',
    'see_all': 'ver tudo',
    'see_item': 'ver {item}',
    'see_less': 'ver menos',
    'see_list_of_item': 'ver lista de {item}',
    'seed': 'seed',
    'select_all': 'selecionar todos',
    'select_date_of_milk_production_instruction': 'Selecione a data referente à produção leiteira do arquivo a ser importado.',
    'select_exported_file': 'Selecione o arquivo exportado do software {software}.',
    'select_exported_file_dairyplan': 'selecione o arquivo exportado do software {software} e preencha com o nome das colunas conforme orientação do time de Sucesso do Cliente (Brinco, Nome, L, Pai, Mae, DtNasc, Reg, Parto, IA, Hora, TouroIA, Stat, DtDg, DtSec, Prod).',
    'select_interval': 'selecione um intervalo',
    'select_one_item_female': 'selecione uma {item}',
    'select_one_item_male': 'selecione um {item}',
    'select_option_and_all_related_options': 'Selecionar esta opção marca automaticamente todas as opções relacionadas a ela',
    'select_spreadsheet_type': 'selecione o tipo de planilha',
    'selected_data': 'dados selecionados',
    'selected_maximum_number_of_items_allowed': 'você atingiu o limite máximo de {max} itens permitidos.',
    'selection_summary': 'Resumo da seleção',
    'selection_summary_subtitle': 'Visualize e valide os critérios aplicados aos seus filtros.',
    'semen_type': 'tipo de sêmen',
    'send': 'enviar',
    'sending': 'enviando...',
    'serial': 'número de série',
    'serum_proteins': 'proteínas séricas',
    'service': 'serviço',
    'service_at': 'Serviço em',
    'service_cycles': 'ciclos de serviços',
    'service_plural': 'serviços',
    'service_rate': 'taxa de serviço',
    'service_type': 'tipo de serviço',
    'services_monthly': 'serviços mensais',
    'services_weekly': 'serviços semanais',
    'set_as_main': 'definir como padrão',
    'settings': 'configurações',
    'SFN_percentage': 'ESD (%)',
    'short_description': 'descrição curta',
    'short_months_apr': 'abr',
    'short_months_aug': 'ago',
    'short_months_dec': 'dez',
    'short_months_feb': 'fev',
    'short_months_jan': 'jan',
    'short_months_jul': 'jul',
    'short_months_jun': 'jun',
    'short_months_mar': 'mar',
    'short_months_may': 'mai',
    'short_months_nov': 'nov',
    'short_months_oct': 'out',
    'short_months_sep': 'set',
    'shortcuts': 'atalhos',
    'show_help': 'clique para exibir ajuda',
    'show_item': 'mostrar {item}',
    'showing_quantity_of_total_results': 'exibindo {quantity} de {total} resultados encontrados',
    'sign_out_of_account': 'sair da conta',
    'signals_and_symptoms': 'Sinais / Sintomas',
    'signed_contracts': 'contratos assinados',
    'signs': 'sinais',
    'site_in_maintenance': 'voltamos já!',
    'site_in_maintenance_text': 'serviço temporariamente indisponível. Nosso time já está atuando para normalizar o acesso, para que você volte a utilizar o sistema em instantes.',
    'skip_item': 'pular {item}',
    'software_download_spreadsheet': 'faça o download da planilha {spreadsheetName} no software {software}.',
    'software_name': 'CowMed',
    'solid_components': 'componentes sólidos',
    'solid_percentage': 'Sólidos (%)',
    'something_went_wrong': 'algo deu errado. Tente novamente.',
    'son_plural': 'filhos',
    'sorry_dont_find_results': 'desculpe, não encontramos resultados para',
    'sort_by': 'ordenar por',
    'source_review': 'revisão de origem',
    'source_voltage': 'tensão da fonte',
    'spacing': 'espaçamento',
    'spacious': 'espaçoso',
    'SPC_x1000': 'CBT (x1000)',
    'special_requirements': 'requisitos especiais',
    'specific_configuration': 'configuração específica',
    'stage_losses': 'perdas por período',
    'start_date': 'data inicial',
    'start_sync': 'data de início (primeiro manejo)',
    'started': 'processando',
    'started_at': 'inicializado em',
    'state': 'estado',
    'status': 'status',
    'status_normalization': 'normalização de status',
    'stillbirth': 'natimorto',
    'storage': 'estoque',
    'strength': 'força',
    'stress_light': 'estresse leve',
    'stress_moderate_to_severe': 'estresse moderado a severo',
    'stress_severe': 'estresse severo',
    'stress_zone': 'zona de estresse',
    'submit_feedback': 'enviar feedback',
    'success': 'finalizado com sucesso',
    'success_with_warnings': 'finalizado com erros',
    'supply_time': 'horário de fornecimento',
    'support': 'suporte',
    'support_notes': 'notas de suporte',
    'suspected_loss': 'suspeita de perdas',
    'suspended_account_message': 'parece que sua conta foi suspensa, entre em contato com o time de suporte ao cliente e sua situação cadastral. Até breve!',
    'suspended_account_title': 'sem acesso a fazendas!',
    'sync_now': 'sincronizar agora',
    'sync_now_message': 'a sincronização com {item} será iniciada agora. Deseja continuar?',
    'synchronized': 'sincronizada',
    'system': 'sistema',
    'system_users': 'usuários do sistema',
    'table_export_warning': "O tamanho desta tabela excede o limite de impressão. Para uma experiência melhor, utilize o recurso de 'Exportar'.",
    'table_view': 'tabela',
    'tag_collar_as': 'marcar coleira como',
    'tag_collar_as_plural': 'marcar coleiras como',
    'tank_analysis': 'análise de tanque',
    'tank_analysis_abreviation': 'adt',
    'technology_by': 'tecnologia por',
    'tecnical_review': 'revisão técnica',
    'temperature': 'temperatura',
    'temperature-humidity-index': 'índice de temperatura-umidade',
    'temporary_suspension': 'suspensão temporária',
    'term_no_results_found': 'sua pesquisa por **{term}** não obteve nenhum resultado. Tente um termo diferente.',
    'term_of_contract': 'vigência do contrato',
    'test_plural': 'testes',
    'thermal_comfort': 'conforto térmico',
    'thermal_comfort_and_rest': 'conforto térmico e descanso',
    'thermal_stress': 'estresse térmico',
    'thi': 'THI',
    'THI_and_intake': 'THI e consumo',
    'this_report_helps_our_team_fix_the_problem': 'este relatório ajuda nossa equipe a corrigir o problema',
    'time_second': 'segundo',
    'time_second_plural': 'segundos',
    'timezone': 'fuso horário',
    'tip_from_female': 'dica da {item}',
    'title': 'título',
    'to_verify': 'verificar',
    'token': 'token',
    'token_consumption': 'consumo de tokens',
    'tokenizable_animals': 'animais tokenizáveis',
    'tokenized_animals': 'animais tokenizados',
    'tokens': 'tokens',
    'tool_plural': 'ferramentas',
    'topology': 'topologia {item}',
    'total': 'total',
    'total_consumption': 'consumo total',
    'total_occurrences': 'total de ocorrências',
    'training_plural': 'treinamentos',
    'transacted_data': 'dados transacionados',
    'transaction_plural': 'movimentações',
    'transactional_emails': 'emails transacionais',
    'transfer_of_passive_immunity': 'Transferência de imunidade passiva (TIP)',
    'transition': 'transição',
    'treated_cases': 'casos tratados',
    'treated_male': 'tratado',
    'treatment': 'tratamento',
    'treatment_plural': 'tratamentos',
    'treatments': 'medicamentos',
    'type': 'tipo',
    'type_description': 'descrição do tipo',
    'type_to_find': 'digite para começar a busca',
    'type_your_message_here': 'digite sua mensagem aqui',
    'unanswered_companies': 'empresas sem resposta',
    'unanswered_farms': 'fazendas sem resposta',
    'unarchive_item': 'desarquivar {item}',
    'uncheck_all': 'desmarcar todos',
    'undo_discart': 'reverter descarte',
    'undo_removal': 'desfazer remoção',
    'unit': 'unidade {item}',
    'unit_plural': 'unidades',
    'unlinked_activity': 'atividade sem vínculo',
    'unlinked_points': 'pontos sem vínculo',
    'unmark': 'desmarcar',
    'unmark_as_unfit': 'desmarcar como',
    'unmonitored_plural': 'não monitorados',
    'unprocessed': 'não processado',
    'unseen': 'não visualizado',
    'unsupported_image_format': 'formato de imagem não suportado, utilize: {formats}',
    'untag_collar': 'desmarcar coleira',
    'untag_collar_message': 'você tem certeza que deseja remover o marcador da coleira?',
    'untag_collar_message_plural': 'você tem certeza que deseja remover o marcador das coleiras?',
    'untag_collar_plural': 'desmarcar coleiras',
    'update_available': 'atualização disponível',
    'update_frequency': 'frequência de atualização',
    'update_item': 'editar {item}',
    'update_registration': 'atualização cadastral',
    'updated_at': 'atualizado em',
    'updated_by': 'atualizado por',
    'upload_file_through_field_below': 'faça upload do arquivo utilizando o campo abaixo',
    'upload_image': 'carregar imagem',
    'UPS_output': 'saída UPS',
    'UPS_QoS': 'QoS UPS',
    'UPS_status': 'UPS (backup)',
    'upsell-churn': 'Upsell / Churn',
    'urea': 'ureia',
    'urea_percentage': 'ureia (%)',
    'use_history': 'histórico de uso',
    'used_treatment': 'tratamento utilizado',
    'useful_links': 'links úteis',
    'user': 'usuário',
    'user_environment': 'ambiente do usuário',
    'user_informations': 'informações do usuário',
    'user_name': 'nome do usuário',
    'user_plural': 'usuários',
    'uses_location': 'usa localização',
    'validated_at': 'validado em',
    'validity': 'vigência',
    'value': 'valor',
    'variability': 'variabilidade',
    'variation_short': 'var.',
    'ventilation_system': 'Sistema de ventilação',
    'version': 'versão',
    'version_updated_at': 'a versão foi atualizada em',
    'VIC': 'VIC',
    'vic_ai_title': 'VIC IA',
    'vic_chat_audio_error_conversion_failed': 'Não foi possível processar o áudio. Grave novamente',
    'vic_chat_audio_error_microphone_denied': 'Permita o acesso ao microfone no navegador para gravar áudio',
    'vic_chat_audio_error_microphone_unavailable': 'Nenhum microfone disponível para gravar áudio',
    'vic_chat_audio_error_too_short': 'Áudio muito curto. Grave novamente',
    'vic_chat_audio_limit_reached': 'Gravação encerrada: limite de 1 minuto atingido',
    'vic_chat_audio_listening': 'VIC está ouvindo seu áudio',
    'vic_chat_audio_message': 'Mensagem transcrita de áudio',
    'vic_chat_audio_recording': 'gravando',
    'vic_chat_audio_stop': 'parar',
    'vic_chat_composer_placeholder': 'Digite sua mensagem aqui',
    'vic_chat_composer_usage_limit_reached': 'Limite mensal da VIC atingido. Reinicia em {date}',
    'vic_chat_conversations_empty': 'nenhum chat',
    'vic_chat_conversations_favorites': 'favoritas',
    'vic_chat_conversations_recent': 'recentes',
    'vic_chat_delete_conversation_confirm_label': 'confirmar exclusão',
    'vic_chat_delete_conversation_label': 'excluir conversa',
    'vic_chat_disclaimer': 'A VIC pode cometer erros. Confira informações importantes no sistema.',
    'vic_chat_fab_label': 'abrir chat com a VIC',
    'vic_chat_favorite_conversation_label': 'marcar como favorita',
    'vic_chat_message_edit_label': 'editar mensagem',
    'vic_chat_message_status_cancelled': 'cancelada',
    'vic_chat_message_status_error': 'erro',
    'vic_chat_message_status_pending': 'pendente',
    'vic_chat_message_status_read': 'lida',
    'vic_chat_message_status_sending': 'enviando',
    'vic_chat_message_status_sent': 'enviada',
    'vic_chat_message_status_streaming': 'respondendo',
    'vic_chat_plan_limits_description': 'Seu plano tem um limite mensal de tokens para conversar com a VIC.',
    'vic_chat_plan_limits_monthly_usage': 'Uso da fazenda',
    'vic_chat_plan_limits_remaining': '{percentage}% restante',
    'vic_chat_plan_limits_resets_in': 'Reinicia em {date}',
    'vic_chat_plan_limits_total_usage': '{used} de {total} tokens',
    'vic_chat_plan_limits_user_usage': '{tokens} tokens · {percentage}% do limite',
    'vic_chat_plan_limits_users_usage': 'Uso por usuário',
    'vic_chat_rename_conversation_label': 'renomear conversa',
    'vic_chat_retry': 'tentar novamente',
    'vic_chat_settings_avatar_placement': 'Identificação da VIC',
    'vic_chat_settings_avatar_placement_hidden': 'oculta',
    'vic_chat_settings_avatar_placement_inline': 'avatar ao lado do nome',
    'vic_chat_settings_avatar_placement_name': 'somente nome',
    'vic_chat_settings_avatar_placement_side': 'avatar ao lado da mensagem',
    'vic_chat_settings_display_description': 'Ajuste a largura, o tamanho da fonte e como a VIC é identificada nas mensagens.',
    'vic_chat_settings_display_title': 'Exibição',
    'vic_chat_settings_drawer_width': 'Largura do painel',
    'vic_chat_settings_drawer_width_large': 'grande',
    'vic_chat_settings_drawer_width_medium': 'média',
    'vic_chat_settings_drawer_width_small': 'pequena',
    'vic_chat_settings_font_size': 'Tamanho da fonte',
    'vic_chat_settings_font_size_extra_large': 'extra grande',
    'vic_chat_settings_font_size_extra_small': 'extra pequeno',
    'vic_chat_settings_font_size_large': 'grande',
    'vic_chat_settings_font_size_medium': 'médio',
    'vic_chat_settings_font_size_small': 'pequeno',
    'vic_chat_settings_page_width': 'Largura da conversa',
    'vic_chat_settings_page_width_full': 'total',
    'vic_chat_settings_page_width_large': 'grande',
    'vic_chat_settings_page_width_medium': 'média',
    'vic_chat_settings_page_width_small': 'pequena',
    'vic_chat_stop_reply_label': 'parar resposta',
    'vic_chat_suggestion_alerts': 'Alertas',
    'vic_chat_suggestion_alerts_value': 'Quais alertas estão abertos na fazenda hoje?',
    'vic_chat_suggestion_animals_batches': 'Animais e lotes',
    'vic_chat_suggestion_animals_batches_value': 'Como estão meus animais e lotes?',
    'vic_chat_suggestion_help': 'Tire dúvidas',
    'vic_chat_suggestion_help_value': 'Como a VIC pode me ajudar no dia a dia da fazenda?',
    'vic_chat_suggestion_routines': 'Rotinas',
    'vic_chat_suggestion_routines_value': 'Quais rotinas tenho para hoje?',
    'vic_chat_token_usage_label': 'tokens utilizados',
    'vic_chat_tool_approval_fallback': 'revise a ação antes de continuar',
    'vic_chat_tool_approved': 'você autorizou esta ação',
    'vic_chat_tool_awaiting_confirmation': 'aguardando confirmação',
    'vic_chat_tool_denied': 'você recusou esta ação',
    'vic_chat_tool_error': 'não foi possível concluir a ação',
    'vic_chat_tool_generic_title': 'ação da VIC',
    'vic_chat_tool_manage_animal_collars_title': 'vincular coleiras',
    'vic_chat_tool_running': 'executando a ação',
    'vic_chat_tool_success': 'ação concluída',
    'vic_chat_tool_unanswered': 'sem resposta',
    'vic_chat_unfavorite_conversation_label': 'remover dos favoritos',
    'vic_gpt_title': 'VIC GPT',
    'vic_routine_subtitle': 'Rotinas e protocolos da fazenda',
    'vic_usage_limit_placeholder': 'limite de uso da VIC atingido neste mês',
    'vic_usage_limit_text': 'Esta fazenda atingiu o limite de uso da VIC neste período. Você poderá conversar novamente a partir de {date}.',
    'vic_usage_limit_title': 'limite de uso atingido',
    'view': 'visualizar',
    'view_all': 'ver todos',
    'view_all_count': 'ver todos os {count}',
    'view_all_notifications': 'visualizar todas as notificações',
    'view_all_tasks': 'visualizar todos processos',
    'view_full_routine': 'visualizar rotina completa',
    'view_history': 'visualizar histórico',
    'view_item': 'visualizar {item}',
    'view_score_chart': 'ver gráfico de escore',
    'viewData': 'ver tabela de dados',
    'visible_columns': 'colunas visíveis',
    'visual_heat': 'cio visual',
    'voluntary_waiting_period_heats': 'cios PEV',
    'VWP_hint': 'PVE (recém-parida)',
    'waiting': 'aguardando {item}',
    'waiting_conditions': 'Aguardando condições...',
    'waiting_time': 'tempo de espera',
    'waiting-artificial-insemination': 'RI-IATF',
    'waiting-embryo-transfer': 'RI-TETF',
    'weaning': 'desaleitamento',
    'webleite': 'Web + Leite',
    'webleite_overview':
        'O Web + Leite é um sistema informatizado de controle e gestão voltado para a pecuária leiteira, utilizado por associações de criadores. Uma vez que o produtor possui acesso, ele pode integrar-se à CowMed.\n\n### Como funciona\n\n1. Acesse o Web + Leite para gerar um novo token.\n2. No menu **Integrações**, acesse a opção **Autenticadores**.\n3. Clique no botão **"+"** para criar um novo acesso, dando o nome CowMed para o acesso.\n4. O Web + Leite irá gerar um token, uma sequência longa de letras e números. Copie esse token.\n5. Aqui na CowMed, clique em **Conectar** e siga os passos para configuração usando o token copiado do Web + Leite.\n\n### Dados disponíveis\n\n- Análise de tanque (leitura)\n- Controle Leiteiro Individual (leitura)',
    'weekdays_friday': 'sexta',
    'weekdays_monday': 'segunda',
    'weekdays_saturday': 'sábado',
    'weekdays_sunday': 'domingo',
    'weekdays_thursday': 'quinta',
    'weekdays_tuesday': 'terça',
    'weekdays_wednesday': 'quarta',
    'weight': 'peso',
    'welcome': 'bem-vindo',
    'what_are_you_looking_for': 'o que você está procurando?',
    'what_do_you_want_to_register': 'o que você quer registrar?',
    'with_attach': 'com vínculo',
    'with_diagnosis': 'com diagnóstico',
    'with_withdrawal_period': 'com carência',
    'without_diagnosis': 'sem diagnóstico',
    'without_diagnostic_text': 'nenhum diagnóstico informado nos últimos {item} dias.',
    'without_information': 'sem informação',
    'without_leading_zeros': 'sem zeros à esquerda',
    'without_withdrawal_period': 'sem carência',
    'write_message': 'escreva sua mensagem',
    'year': 'ano',
    'yes': 'sim',
    'your_software_was_updated': 'seu software tem novas atualizações',
    'zip_code': 'CEP',
} as const

export { pt }
